<template>
  <div class="modal"
       :class="{ 'show-modal': isVisible }"
       tabindex="-1"
       role="dialog"
       :id="idModal">
    <div class="modal-dialog"
         :class="{'modal-dialog-custom' : !isCentered && !isTop, 'modal-dialog-centered' : isCentered}" 
         role="document">
      <div class="modal-content" :style=" {'width': width}">
        <div class="modal-header shadow align-items-center">
          <div class="modal-title">
            <div class="border-icon">
              <i :class="['fa', icon]" class="text-orange"></i>
            </div>
            {{ title }}
          </div>
          <span v-if="showTopClose" 
                class="close-border p-1 mr-2 mt-0"
                @click="cancel">
            <i class="fas fa-window-close close-ico"></i>  {{ cancelText }}
          </span>
        </div>
        <div class="modal-body">
          <slot />
        </div>
        <div class="modal-footer">
          <action-button v-if="showCancel && !showTopClose"
          class="px-4"
                        variant="danger"
                        @click="cancel">
            {{ cancelText }}
          </action-button>
          <action-button v-if="showSave"
                        class="px-4"
                        variant="success"
                        @click="save">
            {{ saveText }}
          </action-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionButton from "@/components/common/ActionButton";

export default {
  name: "CustomModal",
  meta: {
    description: "Componente modal estático personalizado",
    slots: {
      default: {
        type: "component",
        valid: []
      }
    }
  },
  components: {
    ActionButton
  },
  props: {
    value: {
      type: Boolean,
      default: false,
      meta: {
        description: "Parámetro de entrada",
        example: "true"
      }
    },
    title: {
      type: String,
      required: true,
      meta: {
        description: "Especifica el encabezado del modal",
        example: "Texto requerido"
      }
    },
    showSave: {
      type: Boolean,
      required: false,
      default: true,
      meta: {
        description: "Propiedad para mostrar opción de guardar",
        example: "true"
      }
    },
    saveText: {
      type: String,
      required: false,
      default: "Guardar",
      meta: {
        description: "Acción de guardar el texto",
        example: "Guardar"
      }
    },
    showCancel: {
      type: Boolean,
      required: false,
      default: true,
      meta: {
        description: "Propiedad para mostrar opción de cancelar",
        example: "true"
      }
    },
    showTopClose: {
      type: Boolean,
      required: false,
      default: false,
      meta: {
        description: "Muestra la opción Cerrar en la parte superior del modal",
        example: "true"
      }
    },
    cancelText: {
      type: String,
      required: false,
      default: "Cancelar",
      meta: {
        description: "Acción de revocar el texto",
        example: "Cancelar"
      }
    },
    icon: {
      type: String,
      required: false,
      default: "fa-plus",
      meta: {
        description: "Propiedad para el icono",
        example: "fa-plus"
      }
    },
    isCentered: {
      type: Boolean,
      required: false,
      default: () => false
    },
    isTop: {
      type: Boolean,
      required: false,
      default: () => false
    },
    width: {
      type: String,
      required: false,
      default: () => "650px"
    },
    closeOnAnswer: {
      type: Boolean,
      required: false,
      default: () => true
    },
  },
  data(){
    return {
      visible: false
    }
  },
  computed: {
    idModal() {
      return `CustomModal_${this._uid}`;
    },
    isVisible(){
      return this.visible || this.value
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel", false);
      if(this.closeOnAnswer){
        this.visible = false;
      }
    },
    save() {
      this.$emit("save");
      if(this.closeOnAnswer){
        this.visible = false;
      }
    },
    show() {
      this.visible = true;
      this.$emit("showing");
    },
    hide() {
      this.visible = false;
      this.$emit("hiding");
    }
  }
};
</script>
<style scoped>
.show-modal {
  display: block;
}
.modal {
  backdrop-filter: blur(8px);
}
.modal-dialog-custom {
  padding-top: 15vh;
}
.modal-content {
  margin: auto;
}
.modal-dialog {
  max-width: 100vw;
}
.modal-header {
  padding: 8px;
}
.modal-title {
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  padding: 4px 15px;
  font: 900 16px Lato;
}
.modal-footer {
  border-top: none;
  padding-top: 0;
}
.border-icon {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 50px;
  padding-left: 4px;
  padding-right: 4px;
  margin-right: 5px;
  display: inline;
}
.close-border {
  border: 1px solid #2db782;
  border-radius: 50px;
  display: inline-block;
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.6em;
  text-align: center;
  width: 7.1875rem;
  height: 2.6875‬rem;
  cursor: pointer;
  color: #2db782;
}
</style>